"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { CONSENT_CHANGED } from "@/lib/consent";
import { klickIdErfassen, klickIdNachEinwilligung } from "@/lib/klick-id";

/**
 * Nimmt Google-Klick-IDs und UTM-Parameter aus der Adresse auf.
 *
 * Läuft bei jedem Seitenwechsel, weil jemand auch mitten im Besuch über
 * eine Anzeige hereinkommen kann (zweiter Tab, geteilter Link).
 *
 * Der zweite Zuhörer ist der wichtigere: Wer über eine Anzeige kommt,
 * sieht zuerst das Cookie-Banner. Stimmt er zu, darf die Klick-ID erst
 * dann ins Cookie – ohne dieses Nachtragen ginge die Zuordnung bei fast
 * jedem verloren, der das Banner liest, bevor er klickt.
 */
export function KlickIdErfassung() {
  const pfad = usePathname();

  useEffect(() => {
    klickIdErfassen();
  }, [pfad]);

  useEffect(() => {
    const beiEinwilligung = () => klickIdNachEinwilligung();
    window.addEventListener(CONSENT_CHANGED, beiEinwilligung);
    return () => window.removeEventListener(CONSENT_CHANGED, beiEinwilligung);
  }, []);

  return null;
}
